var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGraphLineChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 1.25C2.41421 1.25 2.75 1.58579 2.75 2V17C2.75 19.3472 4.65279 21.25 7 21.25H22C22.4142 21.25 22.75 21.5858 22.75 22C22.75 22.4142 22.4142 22.75 22 22.75H7C3.82436 22.75 1.25 20.1756 1.25 17V2C1.25 1.58579 1.58579 1.25 2 1.25ZM19.8447 5.13574C20.0459 4.7738 20.5022 4.64361 20.8643 4.84473C21.2262 5.04593 21.3564 5.50223 21.1553 5.86426L17.375 12.6689C16.5168 14.2136 14.4454 14.5598 13.1318 13.3779L11.624 12.0205C11.0783 11.5294 10.2288 11.6122 9.78809 12.1992L6.59961 16.4502C6.35102 16.7813 5.88107 16.8481 5.5498 16.5996C5.21871 16.351 5.15194 15.8811 5.40039 15.5498L8.58789 11.2998C9.55715 10.0075 11.4261 9.82492 12.627 10.9053L14.1348 12.2627C14.7319 12.8001 15.6743 12.6426 16.0645 11.9404L19.8447 5.13574Z",
    fill: "#282D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGraphLineChart);
export default __webpack_public_path__ + "static/media/icon-graph-line-chart.4fcec912e500dc2dd39105886bbcc1c4.svg";
export { ForwardRef as ReactComponent };